import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _OqaatAlert;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { Alert } from '@instructure/ui-alerts';
import { Checkbox } from '@instructure/ui-checkbox';
import { View } from '@instructure/ui-view';
import { Text } from '@instructure/ui-text';
import testable from '@instructure/ui-testable';
var OqaatAlert = (_dec = testable(), _dec(_class = (_OqaatAlert = /*#__PURE__*/function (_Component) {
  function OqaatAlert() {
    _classCallCheck(this, OqaatAlert);
    return _callSuper(this, OqaatAlert, arguments);
  }
  _inherits(OqaatAlert, _Component);
  return _createClass(OqaatAlert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        checked = _this$props.checked,
        onChange = _this$props.onChange;
      return /*#__PURE__*/React.createElement(Alert, {
        variant: "info"
      }, /*#__PURE__*/React.createElement(Text, {
        id: "enable-oqaat-info"
      }, t('It is highly recommended that you enable One Question at a Time mode in order to prevent ' + 'students from using the calculator on questions it was not intended for. Changes to this setting will take ' + 'effect immediately.')), /*#__PURE__*/React.createElement(View, {
        as: "div",
        margin: "small 0"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        variant: "toggle",
        size: "small",
        label: t('Enable One Question at a Time'),
        checked: checked,
        onChange: onChange,
        "aria-describedby": "enable-oqaat-info",
        "data-automation": "sdk-one-question-toggle"
      })));
    }
  }]);
}(Component), _defineProperty(_OqaatAlert, "propTypes", {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
}), _OqaatAlert)) || _class);
export { OqaatAlert as default };